import { render } from "./NavigationTemplate.vue?vue&type=template&id=e66198d4"
import script from "./NavigationTemplate.vue?vue&type=script&lang=js"
export * from "./NavigationTemplate.vue?vue&type=script&lang=js"

import "./NavigationTemplate.vue?vue&type=style&index=0&id=e66198d4&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__